// removed by extract-text-webpack-plugin
module.exports = {"formSection":"_2lpp","greyBox":"_1yin"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Services/HostedVoice/PhoneSystemsEdit/PhoneSystemNewEdit.scss
// module id = zP47
// module chunks = 0